export default __webpack_public_path__ + "static/image1-20555c91ae49c39c2e7c6eb946c63328.webp";